module.exports = Studio.libraries['react'];


/*****************
 ** WEBPACK FOOTER
 ** external "Studio.libraries['react']"
 ** module id = 2
 ** module chunks = 0
 **/